<template>
    <div>
        <a :href="user.detail_url">
            <figure class="item-item">
                <div class="image-wrapper">
                    <img :src="user.picture" :alt="user.username" class="product-image">
                </div>

                <figcaption class="item-infos">
                    <h3 class="item-name">@{{ user.username }}</h3>
                </figcaption>
            </figure>
        </a>
    </div>
</template>

<script>
export default {
    props: ['user'],
}
</script>
